module.exports = __webpack_public_path__ + "static/media/tier-7.eba17ebf.jpg";